export default class User {

    constructor(id, email, dayOfBirth, unique, visits, age) {
        this.id = id;
        this.email = email;
        this.dayOfBirth = dayOfBirth;
        this.unique = unique;
        this.visits = visits;
        this.age = age;        
    }

    getAge(date) {

        let months = 0;

        if (!date) return undefined;

        months = (new Date().getFullYear() - date.getFullYear()) * 12;
        months -= date.getMonth() + 1;
        months += new Date().getMonth() + 1;

        if (months <= 0) months = 0;

        const fullYears = Math.trunc(months / 12);
        const fullMonthes = Math.round((months / 12 - Math.trunc(months / 12)) * 12);

        return this.age = `${fullYears > 0 ? fullYears + ' year(s)' : ''} ${fullMonthes > 0 ? fullMonthes + ' month(es)' : ''}`;


    }

}


// WEBPACK FOOTER //
// ./src/classes/User.js